<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="searchDialog" persistent max-width="700px" width="700px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="searchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>بحث في الطلبة</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <div style="margin-top: 20px"></div>

          <v-autocomplete v-model="sectionId" :items="$store.state.sections" item-text="sectionName" item-value="idSection" outlined label="القسم"></v-autocomplete>

          <v-autocomplete v-model="level" :items="levels" item-text="levelName" item-value="level" outlined label="المرحلة"></v-autocomplete>

          <v-autocomplete v-model="paymentTypeId" :items="paymentTypes" item-text="typeName" item-value="idPaymentType" outlined label="الدفعة"></v-autocomplete>

          <v-autocomplete v-model="typeOfPayId" :items="typeOfPay" item-text="name" item-value="id" outlined label="النوع"></v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="searchStudentPaid" v-on:keyup.enter="searchStudentPaid"> بحث </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="mx-2" fab small color="primary" @click="searchDialog = true" v-bind="attrs" v-on="on">
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </template>
      <span>بحث</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    paymentTypes: Array,
  },
  data: () => ({
    searchDialog: false,
    sectionId: "",
    typeOfPayId: "",
    paymentTypeId: "",
    studentRequiredFormRules: [(v) => !!v || "حقل مطلوب . يرجى ادخال قيمة"],
    studentName: "",
    collegeNumber: "",
    overlay: false,
    typeOfPay: [
      { name: "المسددين", id: 1 },
      { name: "غير مسددين", id: 2 },
      { name: "الجميع", id: 3 },
    ],
    levels: [
      { levelName: "المرحلة الاولى", level: 1 },
      { levelName: "المرحلة الثانية", level: 2 },
      { levelName: "المرحلة الثالثة", level: 3 },
      { levelName: "المرحلة الرابعة", level: 4 },
      { levelName: "المرحلة الخامسة", level: 5 },
      { levelName: "جميع المراحل", level: 10 },
    ],
    level: "",
    allSectionInstallments: [],
  }),
  created() {},
  methods: {
    searchStudentPaid() {
      let self = this;
      let query = "studentStatusId = 1";

      if (self.sectionId) {
        query += `&sectionId=${self.sectionId}`;
      }
      // SELECT student.*, levelStudent.level, levelStudent.class ,AcceptedType.acceptedName ,AcceptedType.discount ,Section.sectionName  FROM Student AS student LEFT JOIN LATERAL (SELECT * FROM StudentLevel WHERE studentId = student.idStudent AND currentLevel = 1 LIMIT 1) AS levelStudent ON student.idStudent = levelStudent.studentId JOIN AcceptedType ON student.acceptedTypeId = AcceptedType.idAcceptedType JOIN Section ON Section.idSection = student.sectionId WHERE student.studentStatusId IN (1,4)
      //  ; SELECT * FROM turath_db_studentFees.StudentPayment WHERE turath_db_studentFees.StudentPayment.studyYearId = 75 AND turath_db_studentFees.StudentPayment.notValid = 0 AND StudentPayment.isReceived = 1 AND StudentPayment.isNewStudent = 0 AND  turath_db_studentFees.StudentPayment.paymentTypeId < 10 ;SELECT * FROM turath_db_studentFees.SectionInstallments  WHERE turath_db_studentFees.SectionInstallments.studyYearId = 75
      if (self.level) {
        query += `&level=${self.level}`;
      }
      console.log(query);
      self.$http
        .get(`${self.$store.state.apiUrlRegistration}/v2/paidStudents?${query}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);
          self.overlay = false;
          self.searchDialog = false;
          // OLD calculation block (kept for rollback):
          // Issue: did not subtract StudentDiscountAmount (fixed discount)
          // and did not check StudentAcceptedChannel for per-year discount overrides,
          // so students with these discounts incorrectly appeared unpaid.
          //
          // let studentPay = res.data[0].map((student) => {
          //   const studentPayments = res.data[1].filter(
          //     (pay) => pay.collegeNumber == student.collegeNumber && pay.studentLevel == student.level
          //   );
          //   const installment = res.data[2].find(
          //     (i) => i.sectionId == student.sectionId && i.level == student.level && student.studyType == i.studyType
          //   );
          //   const percent = self.percentagePaidStudentV2(studentPayments, installment);
          //   const feeAfterDiscount = installment?.amount ? (installment.amount * (100 - student.discount)) / 100 : 0;
          //   const remainingAmount = feeAfterDiscount - percent.alreadyPaid;
          //   const isPaid = student.discount >= 100 || remainingAmount <= 0;
          //   return { ... };
          // });

          // NEW calculation: matches trial balance logic
          // - uses StudentAcceptedChannel discount override if present
          // - subtracts StudentDiscountAmount (fixed discount)
          // - sums ALL year-76 payments for the student (no studentLevel filter,
          //   matching trial balance — handles advanced students whose payments
          //   are tagged with old level)
          const fixedDiscounts = res.data[3] || [];
          const channels = res.data[4] || [];

          let studentPay = res.data[0].map((student) => {
            const studentPayments = res.data[1].filter(
              (pay) => pay.collegeNumber == student.collegeNumber
            );

            // OLD effective level (kept for rollback): used student.level from SQL subquery,
            // which sometimes returned a level the student hasn't paid for yet.
            // const effectiveLevel = student.level;

            // NEW: pick the level where the student has the MOST paid amount in year 76.
            // This matches where their payments actually live (e.g., student paid level 1 fees,
            // even if their current StudentLevel record now shows level 2).
            // Falls back to student.level (from subquery) if they have no payments yet.
            const paidByLevel = {};
            studentPayments.forEach((pay) => {
              if (pay.studentLevel != null && pay.paymentTypeId >= 1 && pay.paymentTypeId <= 9) {
                paidByLevel[pay.studentLevel] = (paidByLevel[pay.studentLevel] || 0) + Number(pay.amount || 0);
              }
            });
            let topLevel = student.level;
            let topAmount = -1;
            Object.keys(paidByLevel).forEach((lv) => {
              if (paidByLevel[lv] > topAmount) {
                topAmount = paidByLevel[lv];
                topLevel = Number(lv);
              }
            });
            const effectiveLevel = topLevel;

            const installment = res.data[2].find(
              (i) => i.sectionId == student.sectionId && i.level == effectiveLevel && student.studyType == i.studyType
            );

            // Discount: prefer per-year channel override, fallback to default
            const channel = channels.find(
              (c) => c.studentId == student.idStudent && c.studentLevel == effectiveLevel
            );
            const discount = channel ? Number(channel.channelDiscount) || 0 : Number(student.discount) || 0;

            // Fixed discount from StudentDiscountAmount
            const fixedDiscountRow = fixedDiscounts.find(
              (d) => d.collegeNumber == student.collegeNumber && d.studentLevel == effectiveLevel
            );
            const fixedDiscount = fixedDiscountRow ? Number(fixedDiscountRow.discountAmount) || 0 : 0;

            const percent = self.percentagePaidStudentV2(studentPayments, installment);
            const rawFee = installment?.amount ? Number(installment.amount) : 0;
            const feeAfterPercent = rawFee > 0 && discount < 100 ? (rawFee * (100 - discount)) / 100 : 0;
            const feeFinal = Math.max(0, feeAfterPercent - fixedDiscount);
            const remainingAmount = feeFinal - percent.alreadyPaid;
            const isPaid = discount >= 100 || remainingAmount <= 0;

            return {
              studentName: student.studentName,
              level: effectiveLevel,
              idStudent: student.idStudent,
              acceptedName: channel ? channel.channelAcceptedName : student.acceptedName,
              studyType: student.studyType,
              sectionName: student.sectionName,
              isPaid: isPaid,
              paidPercentage: percent.paid,
              alreadyPaid: percent.alreadyPaid,
              feeFinal: feeFinal,
              remainingAmount: remainingAmount,
              discount: discount,
              fixedDiscount: fixedDiscount,
              collegeNumber: student.collegeNumber,
              mail: student.mail,
              dob: student.dob,
              gender: student.gender,
            };
          });
          console.log(studentPay);
          let data = {
            paymentTypeId: self.paymentTypeId,
            students: self.typeOfPayId == 1 ? studentPay.filter((student) => student.isPaid == true) : self.typeOfPayId == 2 ? studentPay.filter((student) => student.isPaid == false) : studentPay,
          };
          this.$emit("clicked", data);
        })
        .catch((err) => {
          console.log(err);
          self.overlay = false;
        });
    },
    // SELECT student.*, levelStudent.level, levelStudent.class FROM Student AS student LEFT JOIN LATERAL (SELECT * FROM StudentLevel WHERE studentId = student.idStudent AND currentLevel = 1 LIMIT 1) AS levelStudent ON student.idStudent = levelStudent.studentId WHERE student.studentStatusId IN (1,4) HAVING ISNULL(levelStudent.level)

    searchData() {
      let self = this;
      self.overlay = true;
      let query = "studentStatusId = 1";

      if (self.sectionId) {
        query += `&sectionId=${self.sectionId}`;
      }

      if (self.level) {
        query += `&level=${self.level}`;
      }
      self.$http
        .all([
          self.$http.get(`${self.$store.state.apiUrlFees}/filterSectionInstallments?sectionId=${self.sectionId}&studyYearId=76`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrlRegistration}/paidStudents?${query}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
          self.$http.get(`${self.$store.state.apiUrlRegistration}/v2/paidStudents?${query}`, {
            headers: { Authorization: `Bearer ${self.$store.state.user}` },
          }),
        ])
        .then(
          self.$http.spread((sectionInstallments, students, studentV2) => {
            console.log(studentV2);

            self.allSectionInstallments = sectionInstallments.data;

            self.overlay = false;
            let studentPay = students.data.map((student) => {
              return {
                studentName: student.studentName,
                level: student.level,
                idStudent: student.idStudent,
                acceptedName: student.acceptedName,
                studyType: student.studyType,
                sectionName: student.sectionName,
                isPaid: self.studentPayment(student.payments) == "مسدد" ? true : false,
                paidPercentage: self.percentagePaidStudent(student.payments).paid,
                alreadyPaid: self.percentagePaidStudent(student.payments).alreadyPaid,
                discount: student.discount,
                collegeNumber: student.collegeNumber,
                mail: student.mail,
                dob: student.dob,
                gender: student.gender,
              };
            });
            console.log(students.data);
            let data = {
              paymentTypeId: self.paymentTypeId,
              students: self.typeOfPayId == 1 ? studentPay.filter((student) => student.isPaid == true) : self.typeOfPayId == 2 ? studentPay.filter((student) => student.isPaid == false) : studentPay,
            };
            this.$emit("clicked", data);
          })
        )
        .catch((e) => {
          console.log(e);
          self.overlay = false;
        });

      // self.$http
      //   .get(`${self.$store.state.apiUrlRegistration}/paidStudents?${query}`, {
      //     headers: { Authorization: `Bearer ${self.$store.state.user}` },
      //   })
      //   .then((res) => {
      //     self.overlay = false;
      //     let studentPay = res.data.map((student) => {
      //       return {
      //         studentName: student.studentName,
      //         level: student.level,
      //         idStudent: student.idStudent,
      //         acceptedName: student.acceptedName,
      //         studyType: student.studyType,
      //         sectionName: student.sectionName,
      //         isPaid: self.studentPayment(student.payments) == "مسدد" ? true : false,
      //         paidPercentage: self.percentagePaidStudent(student.payments),
      //       };
      //     });
      //     console.log(res.data);
      //     let data = {
      //       paymentTypeId: self.paymentTypeId,
      //       students: self.typeOfPayId == 1 ? studentPay.filter((student) => student.isPaid == true) : self.typeOfPayId == 2 ? studentPay.filter((student) => student.isPaid == false) : studentPay,
      //     };
      //     this.$emit("clicked", data);
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //     self.overlay = false;
      //   });
      this.searchDialog = false;
    },
    percentagePaidStudentV2(payments, sectionInstallment) {
      // OLD logic (kept for rollback): only counted paymentTypeId 1-9.
      // Detail page also includes paymentTypeId 33 (recycled/circular amount),
      // so students with rolled-over balances appeared unpaid here while
      // the detail page showed them as paid.
      // let allPaid = payments.filter((pay) => pay.paymentTypeId >= 1 && pay.paymentTypeId <= 9);

      if (payments && sectionInstallment) {
        // NEW: include paymentTypeId 1-9 AND 33 (recycled), matching the detail page
        let allPaid = payments.filter(
          (pay) => (pay.paymentTypeId >= 1 && pay.paymentTypeId <= 9) || pay.paymentTypeId == 33
        );
        let paid = ((allPaid.reduce((n, { amount }) => n + amount, 0) * 1) / sectionInstallment.amount) * 1 * 100;
        let alreadyPaid = allPaid.reduce((n, { amount }) => n + amount, 0) * 1;

        return {
          paid: Math.floor(paid),
          alreadyPaid: alreadyPaid,
        };
      } else {
        return {
          paid: 0,
          alreadyPaid: 0,
        };
      }
    },

    percentagePaidStudent(payments) {
      let self = this;
      let foundInstallment = self.allSectionInstallments.find((section) => section.sectionId == self.sectionId && section.level == self.level);
      if (payments && foundInstallment) {
        let allPaid = payments.filter(
          (pay) =>
            pay.paymentTypeId == 1 ||
            pay.paymentTypeId == 2 ||
            pay.paymentTypeId == 3 ||
            pay.paymentTypeId == 4 ||
            pay.paymentTypeId == 5 ||
            pay.paymentTypeId == 6 ||
            pay.paymentTypeId == 7 ||
            pay.paymentTypeId == 8 ||
            pay.paymentTypeId == 9
        );
        let paid = ((allPaid.reduce((n, { amount }) => n + amount, 0) * 1) / foundInstallment.amount) * 1 * 100;
        let alreadyPaid = allPaid.reduce((n, { amount }) => n + amount, 0) * 1;

        return {
          paid: Math.floor(paid),
          alreadyPaid: alreadyPaid,
        };
      } else {
        return {
          paid: 0,
          alreadyPaid: 0,
        };
      }
    },
    studentPayment(payments) {
      let self = this;
      if (payments) {
        if (self.paymentTypeId == 1) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 1 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 2) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 2 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 3) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 3 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 4) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 4 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 5) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 5 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 6) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 6 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 7) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 7 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 8) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 8 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        } else if (self.paymentTypeId == 9) {
          let foundPaid = payments.filter((pay) => pay.paymentTypeId >= 9 && pay.paymentTypeId < 10);
          if (foundPaid.length > 0) {
            return "مسدد";
          } else {
            return "غير مسدد";
          }
        }
      } else {
        return "غير مسدد";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
